
<template src="./CoreEPICPolicyHeader.html">
</template>

<script>
  import axios from 'axios'
  import * as epicApi from "@/epicApi.js"
  import locationComponent from "@/components/Location"
  import { mask } from "vue-the-mask"
  import * as common from "@/common.js"
  import { en, fr } from 'vuejs-datepicker/dist/locale'
  import { ValidationProvider, extend } from "vee-validate";
  import i18n from "../../i18n";
  import { ref } from 'vue';
  axios.defaults.headers.common['Pragma'] = 'no-cache';

  extend('policyNumber', {
    validate(value, { rule }) {
      // Allow empty values, since the required rule will catch this instead
      if (!value || !rule || !rule.numberFormat) {
        return true;
      }
      value = value.replaceAll(" ", "");
      if (rule.ignoreHyphens) {
        value = value.replaceAll("-", "");
      }
      if (value.match(rule.numberFormat.toUpperCase())) {
        return true;
      }
      return i18n.t('IncorrectFormat');
    },
    params: ['rule']
  });

export default {
  name: "core-bp-policy-header",
  components: {
    'location-section': locationComponent
  },
  directives: {
    mask
  },
  props: {
    name: {
      type: String
    },
    integrationData: {
      type: Object
    },
    parentData: {
      type: Object
    },
    submit: {
      type: Function
    }
  },
  data() {
    return {
      accountAgencies: [],
      accountBranches: [],
      userDepartments: [],
      userProfitCenters: [],
      currentStates: [],
      datePickerFormat: this.$t("DatePickerFormat"),
      datePickerMask: this.$t("DatePickerMask"),
      policyProducerData: [],
      policyServicerData: [],
      searchingPolicyProducer: false,
      searchingPolicyServicer: false,
      issuingCompanyData: [],
      searchingIssuingCompany: false,
      policyNumberRule: null,
      lineTypes: [],
      lineTypeRequestId: 0
      };
  },
  mounted() {
      this.init();
    },
  watch: {
    'integrationData.policy.policyTypeId': {
      immediate: true,
      handler(policyType) {
        this.loadLineTypes(policyType);
      }
    }
  },
  computed: {
    getDatePickerLocale: function(){
      switch(this.$i18n.locale ) {
        case 'fr':
          return fr;
        default:
          return en;
      }
    },
    policyTypeOptions: function(){
      return this.integrationData.policy.validValues.policyTypes
        .map(option => ({
          ...option,
          name: `${option.id} - ${option.name}`
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    linesOfBusiness: function () {
      return this.lineTypes
        .map(option => ({
          ...option,
          name: `${option.id} - ${option.name}`
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    departments: function() {
      return this.userDepartments
        .map(option => ({
          ...option,
          description: `${option.code} - ${option.description}`
        }))
        .sort((a, b) => a.code.localeCompare(b.code));
    },
    profitCenters: function() {
      return this.userProfitCenters
        .map(option => ({
          ...option,
          description: `${option.code} - ${option.description}`
        }))
        .sort((a, b) => a.code.localeCompare(b.code));
    }
  },
  methods: {
    loadLineTypes(policyType) {
      const requestId = ++this.lineTypeRequestId;
      this.lineTypes = [];
      const policyTypes = this.integrationData.policy.validValues.policyTypes || [];
      const policyTypeIsAvailable = policyTypes.some(option => option.id === policyType);

      if (!policyTypeIsAvailable) {
        this.integrationData.policy.selectedLineOfBusiness = null;
        return;
      }

      epicApi.getEpicLineTypes(
        this.integrationData.epicDestination,
        policyType,
        lineTypes => this.applyLineTypes(requestId, lineTypes),
        error => this.handleLineTypesError(requestId, error));
    },
    applyLineTypes(requestId, lineTypes) {
      if (requestId !== this.lineTypeRequestId) {
        return;
      }

      this.lineTypes = Array.isArray(lineTypes) ? lineTypes : [];
      const selectedLine = this.integrationData.policy.selectedLineOfBusiness;
      if (!selectedLine || !this.lineTypes.some(lineType => lineType.id === selectedLine)) {
        this.integrationData.policy.selectedLineOfBusiness = null;
      }
    },
    handleLineTypesError(requestId, error) {
      if (requestId !== this.lineTypeRequestId) {
        return;
      }

      this.lineTypes = [];
      this.integrationData.policy.selectedLineOfBusiness = null;
      console.log(error);
      throw new Error(error);
    },
    formatIssuingLocationOptions(options = []) {
      return options
        .map(option => ({
          ...option,
          description: `${option.code} - ${option.description}`
        }))
        .sort((left, right) => left.code.localeCompare(right.code));
    },
    init() {
      this.loadStates();
      this.loadStructures();
      this.setServicers();
      this.setIssuingCompany();
    },
    loadStates() {
      // TODO: UPDATE BRANCHING LOGIC HERE
      let countryCode = "USA";
      switch(this.integrationData.epicDestination) {
        case 'US':
          countryCode = "USA";
          break;
        case 'CA':
          countryCode = "CAN";
          break;
      }
      this.setStates(countryCode);
    },

    calculateLineCommission() {
      const { estimatedCommission, estimatedPremium } = this.integrationData.policy;
      if (estimatedCommission && estimatedPremium) {
        const commission = parseFloat(estimatedCommission);
        const premium = parseFloat(estimatedPremium);
        if (!isNaN(commission) && !isNaN(premium) && premium !== 0) {
          const result = (commission / premium) * 100;

          this.integrationData.policy.lineCommission = parseFloat(result.toFixed(2));
          this.integrationData.policy.displayedLineCommission = parseFloat(result.toFixed(2));
          this.lineCommission = parseFloat(result.toFixed(2));
        }
      }
    },

    setStates(countryCode) {
      epicApi.getCountryStatesEPIC(countryCode, this.integrationData.epicDestination, this.setStatesCallback);
    },
    setStatesCallback(states) {
      this.currentStates = this.formatIssuingLocationOptions(states);
    },
    loadStructures() {
      this.accountAgencies = JSON.parse(JSON.stringify(this.integrationData.userValidValues.structureTree.agencies));
      //debugger;
      if (!this.integrationData.account.matchedAccountID) { //create account mode, so pass agency/branch code from account selection
        this.integrationData.policy.agencyCode = this.integrationData.account.agencyCode;
        this.integrationData.policy.branchCode = this.integrationData.account.branchCode;
        this.setDropdownStructure(); //set the rest of dropdowns if values previously selected, a case when a user can dismiss policy popup and click Continue and see it again
      } else {
        if (this.integrationData.policy.agencyCode) {
          //user already has chosen some values or defaults set - do not override (a case when a user can dismiss policy popup and click Continue and see it again)
          this.setDropdownStructure(); //set the rest of dropdowns if values previously selected, a case when a user can dismiss policy popup and click Continue and see it again
        } else {
          this.loadDefaultsAndSetDropdownStructure();
        }
      }
    },
    loadDefaultsAndSetDropdownStructure() {
      this.parentData.isLoading = true;
      return epicApi.getEpicPolicyDefaults(this.integrationData.dynamicsInstanceName,this.integrationData.businessUnitName, this.loadDefaultsCompleted, this.loadDefaultsError);
    },
    loadDefaultsCompleted(response){
      let app = this;
      app.parentData.isLoading = false;
      app.setDefaults(response.data);
    },
    loadDefaultsError(error){
      let app = this;
      app.parentData.isLoading = false;
      console.log(`Failed to load defaults for BU: ${app.integrationData.businessUnitName}`);
      if (error.response && error.response.data && error.response.data.error) {
        console.log(this.$t("ErrorOccurred", { 0: error.response.data.error }));
      }
      else {
        console.log(this.$t("ErrorOccurred", { 0: error }));
        throw new Error(error);
      }
    },
    setDefaults(defaults) {
        if(this.integrationData.policy.agencyCode !== null && this.integrationData.policy.branchCode !== null){
					return;
        }
				if(this.integrationData.policy.agencyCode === null){
					this.integrationData.policy.agencyCode = defaults.defaultAgencyCode;
				}
				if(this.integrationData.policy.branchCode === null){
					this.integrationData.policy.branchCode = defaults.defaultBranchCode;
				}

        /* those below will be used by setStructure only if present in the agency/branch set above */
        this.integrationData.policy.departmentCode = defaults.defaultDepartmentCode;
        this.integrationData.policy.profitCenterCode = defaults.defaultProfitCenterCode;
        this.setDropdownStructure();
    },
    setDropdownStructure() {
      if (this.integrationData.policy.agencyCode) {
        let agency = this.accountAgencies.find(x => x.code == this.integrationData.policy.agencyCode);
        if (agency) {
          this.accountBranches = agency.branches;
          if (this.integrationData.policy.branchCode) {
            let branch = agency.branches.find(x => x.code == this.integrationData.policy.branchCode);
            if (branch) {
              this.userDepartments = branch.departments;
              if (this.integrationData.policy.departmentCode) {
                let department = branch.departments.find(x => x.code == this.integrationData.policy.departmentCode);
                if (department) {
                  this.userProfitCenters = department.profitCenters;
                  let profitCenter = department.profitCenters.find(x => x.code == this.integrationData.policy.profitCenterCode);
                  if (!profitCenter) { //need this final check to reset profitCenterCode to reset validation of not selected PC
                    this.integrationData.policy.profitCenterCode = null;
                  }
                } else {
                  this.integrationData.policy.departmentCode = null;
                  this.integrationData.policy.profitCenterCode = null;
                }
              }
            } else {
              this.integrationData.policy.branchCode = null;
              this.integrationData.policy.departmentCode = null;
              this.integrationData.policy.profitCenterCode = null;
            }
          }
        } else {
          this.integrationData.policy.agencyCode = null;
          this.integrationData.policy.branchCode = null;
          this.integrationData.policy.departmentCode = null;
          this.integrationData.policy.profitCenterCode = null;
        }
      }
    },
    setServicers() {

      if (!this.integrationData.account.matchedAccountID) {
        this.integrationData.policy.servicer = this.integrationData.account.servicer;
      }

      if (this.integrationData.policy.servicer.id) {
        this.policyServicerData.push(common.safeClone(this.integrationData.policy.servicer))
      }
      //if (this.integrationData.policy.producer.id) {
      //  this.policyProducerData.push(common.safeClone(this.integrationData.policy.producer))
      //}
    },
    setIssuingCompany() {
      if (this.integrationData.policy.issuingCompany && this.integrationData.policy.issuingCompany.id) {
        this.issuingCompanyData.push(common.safeClone(this.integrationData.policy.issuingCompany));
        this.getPolicyNumberRule();
      }
    },
    onSubmit() {
      // Call submit from main form
      this.submit();
    },
    callForceCorrectDate(event, vmodel, property) {
      // Couldn't get inline calls to common.js to work. Don't have time at the moment to figure it out. This works, so moving on.
      common.forceCorrectDate(event, vmodel, property);
    },
    callSetInitialExpirationDate(event, vmodel, property) {
      // Couldn't get inline calls to common.js to work. Don't have time at the moment to figure it out. This works, so moving on.
      common.setInitialExpirationDate(event, vmodel, property);
    },
    mapKeydownOverride(map, vselect) {
      map[13] = e => this.suppressEnterWhenLoading(e, vselect);
      return map;
    },
    suppressEnterWhenLoading(e, vselect) {
      if (this.searchingProducer) {
        e.preventDefault();
      }
      else {
        e.preventDefault();
        return vselect.typeAheadSelect();
      }
    },
    onSearchPolicyProducer(search, loading) {
      if (!search) { return; }
      this.searchingPolicyProducer = true;
      loading(true);
      var id = this.integrationData.policy.producer ? this.integrationData.policy.producer.id : 0;
      epicApi.getEpicPolicyProducers(loading, search, id, this.integrationData.epicDestination, this.policyProducerDataGetSet, this.integrationData.businessUnitName, this.integrationData.dynamicsInstanceName);
    },
    policyProducerDataGetSet(apiData) {
      if (apiData) {
        this.policyProducerData = apiData;
        this.searchingPolicyProducer = false;
      }
      else
        return this.policyProducerData;
    },
    onSearchPolicyServicer(search, loading) {
      if (!search) { return; }
      this.searchingPolicyServicer = true;
      loading(true);
      epicApi.getEpicPolicyServicers(loading, search, this.integrationData.policy.servicer.id, this.integrationData.epicDestination, this.policyServicerDataGetSet);
    },
    policyServicerDataGetSet(apiData) {
      if (apiData){
        this.policyServicerData = apiData;
        this.searchingPolicyServicer = false;
      }
      else
        return this.policyServicerData;
    },
    onSearchIssuingCompany(search, loading) {
      if (!search) { return; }
      this.searchingIssuingCompany = true;
      loading(true);
      epicApi.getEpicIssuingCompanies(loading, search, this.integrationData.policy.issuingCompany.id, this.integrationData.epicDestination, this.issuingCompanyDataGetSet, this.integrationData.policy.agencyCode, this.integrationData.policy.branchCode, this.integrationData.policy.departmentCode, this.integrationData.policy.profitCenterCode);
    },
    issuingCompanyDataGetSet(apiData) {
      if (apiData) {
        this.issuingCompanyData = apiData;
        this.searchingIssuingCompany = false;
      }
      else
        return this.issuingCompanyData;
    },
    onChangeAgencyCode(newVal) {
      if (newVal) {
        this.integrationData.policy.departmentCode = null;
        this.integrationData.policy.profitCenterCode = null;
        if (this.integrationData.account.matchedAccountID) {  // if not matched to an account this means this is a new account and branch is defaulted to account branch
          this.integrationData.policy.branchCode = null;
          var agency = this.accountAgencies.find(x => x.code == newVal);
          if (agency) {
            this.accountBranches = agency.branches;
          } else {
            this.integrationData.policy.agencyCode = null;
            this.integrationData.policy.branchCode = null;
            this.integrationData.policy.departmentCode = null;
            this.integrationData.policy.profitCenterCode = null;
          }
        }
      }
    },
    onChangeBranchCode(newVal) {
      if (newVal) {
        this.integrationData.policy.departmentCode = null;
        this.integrationData.policy.profitCenterCode = null;
        var agency = this.accountAgencies.find(x => x.code == this.integrationData.policy.agencyCode);
        var branch = agency.branches.find(x => x.code == newVal);
        if (branch) {
          this.userDepartments = branch.departments;
        } else {
          this.integrationData.policy.branchCode = null;
          this.integrationData.policy.departmentCode = null;
          this.integrationData.policy.profitCenterCode = null;
        }
      }
    },
    onChangeDepartmentCode(newVal) {
      if (newVal) {
        this.integrationData.policy.profitCenterCode = null;
        var agency = this.accountAgencies.find(x => x.code == this.integrationData.policy.agencyCode);
        var branch = agency.branches.find(x => x.code == this.integrationData.policy.branchCode);
        var department = branch.departments.find(x => x.code == newVal);
        if (department) {
          this.userProfitCenters = department.profitCenters;
        } else {
          this.integrationData.policy.departmentCode = null;
          this.integrationData.policy.profitCenterCode = null;
        }
      }
    },
    onChangeLineCommission(newVal) {
      if (newVal)
        this.integrationData.policy.lineCommission = common.parsePercent(newVal);
      else
        this.integrationData.policy.lineCommission = newVal;
    },
    getAgencyLabel() {
      if (this.integrationData.account.matchedAccountID)
        return this.$t('UserAgency');
      else
        return this.$t('Agency');
    },
    getBranchLabel() {
      if (this.integrationData.account.matchedAccountID)
        return this.$t('UserBranch');
      else
        return this.$t('Branch');
    },
    getPolicyNumberRule() {
      if (this.integrationData.policy.issuingCompany.id && this.integrationData.policy.policyTypeId) {
        epicApi.getPolicyNumberFormat(this.integrationData.policy.issuingCompany.id, this.integrationData.policy.policyTypeId, this.policyNumberFormatDataGetSet);
      } else {
        this.policyNumberRule = null;
      }
    },
    policyNumberFormatDataGetSet(apiData) {
      if (apiData) {
        this.policyNumberRule = apiData;
      }
      else {
        this.policyNumberRule = null;
      }
    }
  }
};
</script>
